import { FC, memo } from 'react';

import { ImageData } from '../VariationOne';
import SharedUploadedImageRow from '../shared/UploadedImageRow';

interface Props {
  image: ImageData;
  imageIndex: number;
  setImages: React.Dispatch<React.SetStateAction<ImageData[]>>;
}

const UploadedImageRow: FC<Props> = ({
  image,
  imageIndex,
  setImages,
}) => {

  return (
    <SharedUploadedImageRow
      image={image}
      imageIndex={imageIndex}
      setImages={setImages as any}
      showText={false}
      showSettings={false}
      showPreview={false}
      aspectRatio={700 / 883}
      imgRatioX={61}
      imgRatioY={76}
    />
  );
};

export default memo(UploadedImageRow);
